import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { FormContainer } from 'react-hook-form-mui'
import SkipNavigation from '../../components/SkipNavigation'
import CustomHeader from '../../components/CustomHeader'
import PageHeader from '../../components/PageHeader'
import { AcademicUnitAndInstructorAddedQuestionsFeature } from '../../features/AcademicUnitAndInstructorAddedQuestionsFeature'
import PAGE_TITLES from '../../consts/titles'
import useAsyncEffect from 'use-async-effect'
import { useDispatch } from 'react-redux'
import { resetState, setEditableSurvey } from '../../store/slices/SurveyTemplateSlice'
import SurveyHeader from './Header'
import { ADDED_QUESTION_TYPES } from '../../consts/addedQuestionTypes'
import LoadingPageV2 from '../LoadingPageV2'
import { AutoImportManager } from '../../APIManager'

const AcademicUnitAndInstructorAddedQuestions = (): React.ReactElement => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const slotId = params.get('slotId')
  const divisionId = params.get('divisionId')
  const categoryName = params.get('categoryName')
  const type = params.get('type')
  const addedQuestionCount = params.get('addedQuestionCount')
  const dispatch = useDispatch()

  const { data: adminQuestions, isLoading, isFetching } = useQuery({
    queryKey: [type === ADDED_QUESTION_TYPES.INSTRUCTOR ? 'instructorQuestions' : 'adminQuestions', slotId, divisionId],
    queryFn: async () => {
      if (type === ADDED_QUESTION_TYPES.INSTRUCTOR) {
        return await AutoImportManager.getAllInstructorQuestions(slotId ?? '', divisionId ?? '')
      } else {
        return await AutoImportManager.getAllAdminQuestions(slotId ?? '', divisionId ?? '')
      }
    },
    enabled: !!slotId && !!divisionId && Number(addedQuestionCount) > 0
  })

  useAsyncEffect(() => {
    dispatch(resetState())
    if (adminQuestions?.data) {
      dispatch(setEditableSurvey({
        title: 'title',
        surveySections: [adminQuestions?.data]
      }))
    }
  }, [adminQuestions])

  if (isLoading || isFetching) {
    return <LoadingPageV2 />
  }

  return (
    <FormContainer>
      <SkipNavigation />
      <CustomHeader title={type === ADDED_QUESTION_TYPES.INSTRUCTOR ? PAGE_TITLES.INSTRUCTOR_ADDED_QUESTION : PAGE_TITLES.ADMIN_ADDED_QUESTION} />
      <PageHeader
        title={`${categoryName} Questions`}
        isCompactOnly
        showBackButton
        controls={
          <SurveyHeader />
        }
      />
      <AcademicUnitAndInstructorAddedQuestionsFeature />
    </FormContainer>
  )
}

export default AcademicUnitAndInstructorAddedQuestions
